import React, { createContext, useContext, useState, useEffect } from 'react'
import { verifyToken } from '../api/authApi'
import axios from '../api/axiosConfig'

const AuthContext = createContext()

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isAuthenticated: false,
    isLoading: true,
    user: null,
  })

  // This effect runs once on application startup
  useEffect(() => {
    const validateSession = async () => {
      try {
        // Instead of checking localStorage, go directly to server validation
        // The cookie will be sent automatically with the request
        const result = await verifyToken()

        if (result.status) {
          // Store user data in context only (not localStorage)
          setAuth({
            isAuthenticated: true,
            isLoading: false,
            user: {
              fullName: result.data.fullName,
              role: result.data.role,
              permissions: result.data.permissions || [],
            },
          })
        } else {
          // Authentication failed
          setAuth({
            isAuthenticated: false,
            isLoading: false,
            user: null,
          })
        }
      } catch (error) {
        console.error('Auth validation error:', error)
        setAuth({
          isAuthenticated: false,
          isLoading: false,
          user: null,
        })
      }
    }

    validateSession()
  }, [])

  const login = (userData) => {
    setAuth({
      isAuthenticated: true,
      isLoading: false,
      user: userData,
    })
  }

  const logout = () => {
    setAuth({
      isAuthenticated: false,
      isLoading: false,
      user: null,
    })
  }

  // Check if user has permission for a specific feature
  const hasPermission = (permissionKey) => {
    // Super admin has access to everything
    if (auth.user?.role === 'SUPER_ADMIN') {
      return true
    }
    // Check if this permission is in the user's permission array
    return auth.user?.permissions?.includes(permissionKey) || false
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: auth.isAuthenticated,
        isLoading: auth.isLoading,
        user: auth.user,
        login,
        logout,
        hasPermission,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
